import { ReportManagementsArray } from './ReportManagementGetResponse';

export const EmptyReportManagementDeleteItem: ReportManagementsArray = {
  id: 0,
  date: '',
  employeeCode: 0,
  employeeName: '',
  projectId: 0,
  projectNumber: '',
  projectName: '',
  manHoursCategory: '',
  startTime: '',
  endTime: '',
  manHoursTotal: 0,
};
